var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M19.767 6.332l-5-5.952c-.415-.454-1.078-.498-1.513-.148-.435.35-.508 1.056-.15 1.483l3.56 4.235H1.07C.48 5.95 0 6.42 0 7c0 .58.48 1.05 1.071 1.05h15.593l-3.56 4.235c-.358.427-.277 1.123.15 1.483.44.37 1.157.28 1.512-.148l5-5.952c.326-.449.298-.902 0-1.335z"}));
}

ArrowRight.defaultProps = {"width":"20","height":"14","viewBox":"0 0 20 14"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
